<template>
    <div class="modal fade " tabindex="-1" role="dialog" id="modalTransfert">
        <div class="modal-dialog">
            <div class="modal-content">

                <div class="overlay ModalOverlay" v-if="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                </div>

                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">×</span></button>
                    <h4 class="modal-title"> {{ title }}</h4>
                </div>

                <div class="modal-body">
                    <div v-if="licence">
                        <div class="form-group" :class="{'has-error': errors.has('transfert[date_inscription]') }">
                            <label>Date de transfert</label>
                            <div class="input-group date">
                                <div class="input-group-addon">
                                    <i class="fa fa-calendar"></i>
                                </div>
                                <masked-input type="text"
                                              v-model="transfert.date_inscription"
                                              v-validate="'date_format:DD/MM/YYYY'"
                                              :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                              :guide="true"
                                              :keepCharPositions="true"
                                              :showMask="true"
                                              name="transfert[date_inscription]"
                                              class="form-control pull-right datepicker"
                                              id="datepicker2"
                                >
                                </masked-input>
                            </div>
                        </div>
                        <span v-show="errors.has('transfert[date_inscription]')"
                              class="help-block">Date incorrecte</span>


                        <list-select-club
                                :clubsLicenciesUniquement="true"
                                title="Club d'origine"
                                :clubPreSelected="licence.id_club"
                                @clubSelected="updateClubOrigineSelected"

                        ></list-select-club>

                        <list-select-club
                                :clubsLicenciesUniquement="true"
                                title="Club de destination"
                                :clubPreSelected="0"
                                @clubSelected="updateClubDestinationSelected"
                                :notShowIdClub="licence.id_club"
                        ></list-select-club>

                    </div>
                </div>

                <div class="modal-footer">
                    <button v-if="showCloseBtn" type="button" class="btn btn-default pull-left" data-dismiss="modal">
                        Fermer
                    </button>
                    <button type="button" class="btn btn-primary"
                            @click="linkMember()"
                            :disabled="transfert.id_club_destination==0 || transfert.id_club_origine==0">
                        {{titleSubmit}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import {mapGetters, mapActions} from 'vuex'
    import ListSelectClub from '../../Communs/listeSelectClub'
    import {ErrorBag} from 'vee-validate';

    var $ = require('jquery');
    var variables = require('../../../assets/js/variables')
    var _ = require('underscore')
    var moment = require('moment')

    export default {
        props: {
            licence: Object,
            showModalTransfert: Boolean,
            title: String,
            showCloseBtn: {
                default: true
            },
            titleSubmit: {
                type: String,
                default: 'Enregistrer'
            }
        },
        data() {
            return {
                transfert: {
                    date_inscription: moment().format('DD/MM/YYYY'),
                    id_club_origine: this.licence ? this.licence.id_club : 0,
                    id_club_destination: 0,
                },
                loading: false,
            }
        },
        methods: {
            updateClubDestinationSelected: function (value) {
                this.transfert.id_club_destination = value.id
            },
            updateClubOrigineSelected: function (value) {
                this.transfert.id_club_origine = value.id
            },
            linkMember: function () {
                this.$emit('addTransfert', this.transfert)
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
            })
        },
        watch: {
        },
        components: {
            ListSelectClub,
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/Secretariat/Membre/ModalAddTransfert.vue